import { Component } from "@angular/core";

@Component({
  selector: "app-terms-of-service",
  templateUrl: "./terms-of-service.component.html",
})
export class TermsOfServiceComponent {}
